import { MessageType, AgentRecordingMessageType, MessageFlags } from 'app/modules/remote-control-ng/definitions';
import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';
import { IAgentVideoRecordingSettings } from 'app/modules/remote-control/services/remote-control.interfaces';

export interface IAgentVideoRecordingResult {
    deviceId: string;
    videoPath?: string;
    errorCode: number;
}

/** PC_AGENT_RECORD MessageType */
export class AgentRecordingMessage extends BaseMessage {
    protected settings?: IAgentVideoRecordingSettings;
    public response?: IAgentVideoRecordingResult;
    public messageType: AgentRecordingMessageType | 0;

    constructor(settings?: IAgentVideoRecordingSettings) {
        super();
        this.settings = settings;
        this.header.command = MessageType.PC_AGENT_RECORD;
    }

    public deserializeBody(buffer: MemoryBuffer): void {
        this.response = <IAgentVideoRecordingResult>{};
        this.messageType = buffer.readUInt8();
        if (!(this.header.flags & MessageFlags.HAS_REQID)) {
            // we did not request it which means request was initiated form device side
            // so we emit event corresponding to the type of annotation message instead
            if (this.messageType === AgentRecordingMessageType.ARM_STOP_RECORDING) {
                this.response.videoPath = buffer.readString();
                this.response.errorCode = buffer.readUInt32BE();
            }
        }
    }
}

/** PC_AGENT_RECORD MessageType, ARM_START_RECORDING subcommand */
export class AgentRecordingStartMessage extends AgentRecordingMessage {
    public serializeBody(buffer: MemoryBuffer) {
        buffer.writeUInt8(AgentRecordingMessageType.ARM_START_RECORDING);
        buffer.writeUInt16BE(this.settings.screenWidth);
        buffer.writeUInt16BE(this.settings.screenHeight);
        buffer.writeUInt16BE(this.settings.videoFrameRate);
        buffer.writeUInt32BE(this.settings.videoBitRate);
        buffer.writeUInt32BE(this.settings.audioSamplingRate);
        buffer.writeUInt32BE(this.settings.audioBitRate);
        buffer.writeStringLE('');
        buffer.writeUInt32BE(0);   // video recording size limit by size (MB), for now server will override
        buffer.writeUInt32BE(0);   // video recording size limit by time (seconds), for now server will override
    }
}

/** PC_AGENT_RECORD MessageType, ARM_GET_RECORDING subcommand */
export class AgentRecordingGetMessage extends AgentRecordingMessage {
    public serializeBody(buffer: MemoryBuffer) {
        buffer.writeUInt8(AgentRecordingMessageType.ARM_GET_RECORDING);
    }
}

/** PC_AGENT_RECORD MessageType, ARM_STOP_RECORDING subcommand */
export class AgentRecordingStopMessage extends AgentRecordingMessage {
    public serializeBody(buffer: MemoryBuffer) {
        buffer.writeUInt8(AgentRecordingMessageType.ARM_STOP_RECORDING);
    }
}

/** PC_AGENT_RECORD MessageType, ARM_PAUSE_RECORDING subcommand */
export class AgentRecordingPauseMessage extends AgentRecordingMessage {
    public serializeBody(buffer: MemoryBuffer) {
        buffer.writeUInt8(AgentRecordingMessageType.ARM_PAUSE_RECORDING);
    }
}

/** PC_AGENT_RECORD MessageType, ARM_RESUME_RECORDING subcommand */
export class AgentRecordingResumeMessage extends AgentRecordingMessage {
    public serializeBody(buffer: MemoryBuffer) {
        buffer.writeUInt8(AgentRecordingMessageType.ARM_RESUME_RECORDING);
    }
}
